export default __webpack_public_path__ + "static/media/ratna-nidhi.439cd188.png";